import { lang } from '@umu/ukit-lang';
import React, { useCallback, useRef, useState } from 'react';
import ReactCrop, { Crop, PercentCrop } from 'react-image-crop';
import './toBlob';
import { $document } from '@umu/umu-dom';
import { components } from 'common';
const { If } = components;
import { UploadLoading } from '../@uploadLoading/uploadLoading';
import { EMediaType } from '@umu/umu-types';
import { getUploadResult } from '../../services/uploader/uploader';

interface IProps {
    src: string;
    aspect: number;
    teacherId: string;
    isPCCrop?: boolean;
    onErr(): void;
    onCancel(): void;
    onConfirm(data: string): void;
}

const pixelRatio = window.devicePixelRatio || 1;

import './reactCrop.scss';
import './imgCropPortal.scss';

// const orientation = {
//     1: 0,
//     6: 'transform: rotateZ(-90deg) translateX(-100%);transform-origin: 0% 0%;', // 90
//     8: 'transform: rotateZ(90deg) translateY(-100%);transform-origin: 0% 0%;', // -90
//     3: 180,
// };

/**
 * @desc 图片裁切浮层
 * @author Kody
 */
export const ImgCropPortal = (props: IProps) => {
    const { src, teacherId, aspect = 16 / 9, onCancel, onConfirm, onErr } = props;
    const imgRef = useRef<HTMLImageElement>();
    const canvasRef = useRef<HTMLCanvasElement>();
    const [disabled, setDisabled] = useState(true);
    const [naturalWidth, setNaturalWidth] = useState<number>(0);
    const [naturalHeight, setNaturalHeight] = useState<number>(0);
    const [completedCrop, setCompletedCrop] = useState<Crop | null>(null);
    const [crop, setCrop] = useState<Crop>({ unit: '%', width: 100, aspect });
    // const imgExif = useImgExif(src);

    const onLoad = useCallback((img) => {
        imgRef.current = img;
        setNaturalWidth(img.naturalWidth);
        setNaturalHeight(img.naturalHeight);
        const canvas = $document.createElement('canvas');
        canvasRef.current = canvas;
        setDisabled(false);
    }, []);

    const onCropChange = (newCrop: Crop, _percentCrop: PercentCrop) => {
        setCrop(newCrop);
    };

    const onCropComplete = (newCrop: Crop, _percentCrop: PercentCrop) => {
        setCompletedCrop(newCrop);
    };

    const blobBack = (blob: Blob | null) => {
        if (!blob) {
            onErr();
            return;
        }
        const previewUrl = window.URL.createObjectURL(blob);
        const param = {
            blob,
            ext: 'png',
            previewUrl,
            fileName: '',
            mediaType: EMediaType.IMAGE,
            teacherId,
        };
        getUploadResult(param)
            .then((payloadData) => {
                setDisabled(false);
                UploadLoading.hide();
                window.URL.revokeObjectURL(previewUrl);
                onConfirm(payloadData.url);
            })
            .catch(() => {
                setDisabled(false);
                UploadLoading.hide();
                window.URL.revokeObjectURL(previewUrl);
                onErr();
            });
    };

    const confirmHandle = () => {
        const image = imgRef.current!;
        const canvas = canvasRef.current!;
        if (!completedCrop || disabled) {
            return;
        }
        setDisabled(true);
        UploadLoading.show({ message: lang('图片生成中') });
        const scaleX = naturalWidth / image.width;
        const scaleY = naturalHeight / image.height;
        const completedCropWidth = completedCrop.width || 200;
        const completedCropHeight = completedCrop.height || completedCropWidth / aspect;
        const width = (completedCrop.width || completedCropWidth) * pixelRatio;
        const height = (completedCrop.height || completedCropHeight) * pixelRatio;
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d')!;
        ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);

        // if (imgExif !== null) {
        //     const Orientation = imgExif!.Orientation;
        // }
        // ctx.rotate(-Math.PI / 2);
        // ctx.translate(-100, 0);
        // image.setAttribute('style', 'transform: rotateZ(90deg) translateY(-100%);transform-origin: 0% 0%;');

        // setTimeout(() => {
        //     ctx.drawImage(
        //         image,
        //         0,
        //         0,
        //         width * scaleX,
        //         height * scaleY,
        //         0,
        //         0,
        //         width,
        //         height,
        //     );
        //     document.querySelector('.img-crop-portal')!.appendChild(canvas);
        // // const wrapctx = document.createElement('canvas');
        // }, 1000);

        const img = document.createElement('img');
        let url = src;
        if (!/blob/.test(src)) {
            url = `${src}${/\?/.test(src) ? '&' : '?'}t=${Date.now()}`;
        }
        img.src = url;
        img.crossOrigin = 'anonymous';
        img.onload = () => {
            setTimeout(() => {
                ctx.drawImage(
                    img,
                    completedCrop.x! * scaleX,
                    completedCrop.y! * scaleY,
                    completedCropWidth * scaleX,
                    completedCropHeight * scaleY,
                    0,
                    0,
                    completedCropWidth,
                    completedCropHeight,
                );
                canvas.toBlob(blobBack, 'image/png', 1);
            }, 1000);
        };
        img.onerror = onErr;
    };

    const render = () => {
        return (
            <>
                <If condition={!!props.isPCCrop}>
                    <div className="pc-ngdialog-overlay"></div>
                </If>
                <div className="img-crop-portal">
                    <If condition={!!props.isPCCrop}>
                        <div className="panel-header">{lang('封面图')}</div>
                    </If>
                    <div className="crop-area">
                        <ReactCrop
                            src={src}
                            crop={crop}
                            keepSelection={true}
                            onImageLoaded={onLoad}
                            onChange={onCropChange}
                            onComplete={onCropComplete}
                        />
                    </div>
                    <div className="btn-area">
                        <button onClick={onCancel} className="btn-opera cancel">
                            {lang('取消')}
                        </button>
                        <button onClick={confirmHandle} className={`btn-opera confirm ${disabled ? 'disabled' : ''}`}>
                            {lang('确定')}
                        </button>
                    </div>
                </div>
            </>
        );
    };
    return render();
};
